import React from "react";
import { TextField } from "@mui/material";
import {word} from "../../word.js";

const TextAreaTask = ({ item, index, setFormData, submitted }) => {
    const handleTextChange = (value) => {
        setFormData((prevForm) =>
            prevForm.map((el, i) => (i === index ? { ...el, value, valid: value.length > 0 } : el))
        );
    };

    const handleBlur = () => {
        setFormData((prevForm) => prevForm.map((el, i) => (i === index ? { ...el, active: false } : el)));
    };

    const handleFocus = () => {
        setFormData((prevForm) => prevForm.map((el, i) => (i === index ? { ...el, active: true } : el)));
    };

    return (
        <div className={!item.valid && submitted ? "input-validation input-validation-valid" : "input-validation"} key={index}>
            <TextField
                name={item.key}
                value={item.value}
                onChange={(e) => handleTextChange(e.target.value)}
                onBlur={handleBlur}
                onFocus={handleFocus}
                label={word[item.key]}
                multiline
                variant="outlined"
                error={!item.valid && submitted}
                className={!item.valid && submitted ? "validation-outlined-input" : "outlined-helperText"}
            />
            {!item.valid && submitted && <div className="validation valid-center">{word[item.errorMessage]}</div>}
        </div>
    );
};

export default TextAreaTask;
